import { TableActions } from '@core/components/Table';
import { permissaoUtils } from '@core/util/permissaoUtil';
import DeleteIcon from '@material-ui/icons/Delete';
import React, { useContext } from 'react';
import { FaCreditCard, FaDonate, FaUniversity } from 'react-icons/fa';
import { ContaContext } from '../../ContaContext';
import { modaisConta } from '../modal/modais';

const ContaFab = ({ onDelete }) => {
  const [, setModal] = useContext(ContaContext).modal;
  const [selecao] = useContext(ContaContext).selecao;
  const [tipoSelecao] = useContext(ContaContext).tipoSelecao;
  const [, setContaAtual] = useContext(ContaContext).contaAtual;
  const [search] = useContext(ContaContext).search;

  const triggerCreate = (modal) => {
    setContaAtual({});
    setModal(modal);
  };

  const triggerDelete = () => {
    onDelete({ ids: selecao, q: search, tipoSelecao });
  };

  const actions = [
    {
      icon: <DeleteIcon />,
      name: 'delete',
      tooltip: 'Excluir',
      show: permissaoUtils.conta().excluir && (tipoSelecao === 'TODOS_FILTRO' || selecao.length > 0),
      onClick: triggerDelete,
    },
    {
      icon: <FaDonate />,
      name: 'createContaCaixinha',
      tooltip: 'Cadastrar conta caixinha',
      show: permissaoUtils.conta().cadastrar,
      onClick: () => triggerCreate(modaisConta.editarContaCaixinha),
    },
    {
      icon: <FaCreditCard fontSize="small" />,
      name: 'createCartao',
      tooltip: 'Cadastrar cartão de crédito',
      show: permissaoUtils.conta().cadastrar,
      onClick: () => triggerCreate(modaisConta.editarContaCartao),
    },
    {
      icon: <FaUniversity size="20" />,
      name: 'createContaBancaria',
      tooltip: 'Cadastrar conta bancária',
      show: permissaoUtils.conta().cadastrar,
      onClick: () => triggerCreate(modaisConta.editarContaBancaria),
    },
  ];

  return <TableActions actions={actions} />;
};

export default ContaFab;
